import { render, staticRenderFns } from "./loginNew.vue?vue&type=template&id=78a19347&"
import script from "./loginNew.vue?vue&type=script&lang=ts&"
export * from "./loginNew.vue?vue&type=script&lang=ts&"
import style0 from "./loginNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports